import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from '../insecta.base.service';
import { ILocation, ILocationAddRequest, ILocationUpdateRequest } from '../insecta.models';

@Injectable({
  providedIn: `root`
})
export class LocationAdminService extends InsectaServiceBase {
  public getLocation(id: string): Observable<ILocation> {
    return this.get<ILocation>(`/admin/locations/${id}`, 'v1');
  }

  public getLocationsForHierarchy(): Observable<ILocation[]> {
    return this.get<ILocation[]>(`/admin/locations/structured`, 'v1');
  }

  public addLocation(request: ILocationAddRequest): Observable<any> {
    return this.post<string>(`/admin/locations`, 'v1', request);
  }

  public updateLocation(request: ILocationUpdateRequest): Observable<any> {
    return this.put(`/admin/locations/${request.id}`, 'v1', request);
  }
}
